<template>
  <div class="user-mgt-page">
    <div class="global-header-wrap">
      <span>设备管理</span>
      <button class="global-button-style" @click="$router.back()">
        {{ $t("commonMsg.back") }}
      </button>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          @submit.native.prevent
          label-width="90px"
          class="global-page-form"
        >
          <el-form-item label="品牌" prop="brand">
            <el-input type="text" v-model="ruleForm.brand"></el-input>
          </el-form-item>
          <el-form-item label="编译版本" prop="buildId">
            <el-input type="text" v-model="ruleForm.buildId"></el-input>
          </el-form-item>
          <el-form-item label="设备唯一id" prop="deviceUniqueId">
            <el-input type="text" v-model="ruleForm.deviceUniqueId"></el-input>
          </el-form-item>
          <el-form-item label="指纹信息" prop="fingerprint">
            <el-input type="text" v-model="ruleForm.fingerprint"></el-input>
          </el-form-item>
          <el-form-item label="im账号" prop="imAccount">
            <el-input type="text" v-model="ruleForm.imAccount"></el-input>
          </el-form-item>
          <el-form-item label="详情" prop="details">
            <el-input type="text" v-model="ruleForm.details"></el-input>
          </el-form-item>
          <el-form-item label="型号" prop="model">
            <el-input type="text" v-model="ruleForm.model"></el-input>
          </el-form-item>
          <el-form-item label="MAC" prop="macAddress">
            <el-input type="text" v-model="ruleForm.macAddress"></el-input>
          </el-form-item>
          <el-form-item label="高度" prop="height">
            <el-input type="text" v-model="ruleForm.height"></el-input>
          </el-form-item>
          <el-form-item label="宽度" prop="width">
            <el-input type="text" v-model="ruleForm.width"></el-input>
          </el-form-item>
          <el-form-item>
            <button class="global-button-style" @click="submitForm('ruleForm')">
              {{ $t("commonMsg.save") }}
            </button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  computed: {
    rules() {
      let rules = {
        macAddress: [
          { required: true, message: "请输入MAC地址", trigger: "blur" }
        ],
        deviceUniqueId: [
          { required: true, message: "请输入deviceUniqueId", trigger: "blur" }
        ],
        model: [{ required: true, message: "请输入设备型号", trigger: "blur" }]
      };
      return rules;
    }
  },
  data() {
    return {
      ruleForm: {
        brand: "", // 品牌
        buildId: "", // 编译版本
        deviceUniqueId: "", // 设备唯一id
        fingerprint: "", // 指纹信息
        imAccount: "", // im账号
        details: "", // 详情
        model: "", // 型号
        macAddress: "", // MAC
        height: 0,
        width: 0
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.create();
        } else {
          return false;
        }
      });
    },
    async create() {
      await this.$http.addFacilitys(this.ruleForm);
      this.$router.back();
      this.elMsg(this.$t("alertMsg.addSuccess"), "success");
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
.user-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    height: 100%;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .user-mgt-select-org {
        color: $globalLessBGColor;
        cursor: pointer;
        font-weight: bold;
      }
      .el-form-item {
        .el-select {
          width: 100%;
        }
        .el-textarea__inner {
          height: 150px;
        }
      }
      .global-button-style {
        width: 100%;
        margin: 0;
      }
    }
  }
}
</style>
